export default __webpack_public_path__ + "static/media/route_planner.8d1b1ea3.png";